import { LatLonLocation } from './node-models.interface';
import { ObjID } from './object-id.interface';
import { KeyValuePair } from './views.interface';

/**
 * Models for importing triggers and actions from backend
 */

export interface GetProductsModel {
	currentTime: string;
	products: ProductInfoModel[];
}

export interface ProductInfoModel {
	product: ProductModel;
	productFriendlyName: string;
	triggers: BackendNodeModel[];
	actions: BackendNodeModel[];
}

export interface BaseProduct {
	id: ObjID;
	name: string;
	thresholdConfig?: ThresholdConfig;
}

export interface ProductModel extends BaseProduct {
	lastEventTimestamp: string;
	createdAt: string;
}

export interface Product extends BaseProduct {
	triggers: NodeModel[];
	actions: NodeModel[];
	lastHeardFrom?: number;
	thresholdExceeded?: boolean;
}

export interface ThresholdConfig {
	enabled: boolean;
	timeNumber: number;
	timeUnits: string;
	sendEmails: boolean;
}

// Possible values for threshold timeUnits
export enum ThresholdTimeUnit {
	minutes = 60,
	hours = 3600,
	days = 86400,
}

export interface BackendNodeModel extends CoreNodeModel {
	segmentName?: string;
}

export type NodeModel = CoreNodeModel;

export interface CoreNodeModel {
	ecosystemId?: string;
	id: string;
	friendlyName: string;
	friendlyNameStatic: string;
	ttl?: number;
	segmentId?: string;
	metadataList?: KeyValuePair[];
	isCritical?: boolean;
	location?: LatLonLocation;
}

export interface FeedbackModel {
	feedbackType: string;
	title: string;
	details: string;
}

export interface AgencyModel {
	id: ObjID;
	globalWorkflowEnabled: boolean;
	hasHadDefaultRolesCreated: boolean;
	suppressionDisabled: boolean;
	enablements: string[];
	awareIntegrationEnabled?: boolean;
	location?: { latitude: number; longitude: number };
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
